import { Button } from '@mui/material';
import { formatDate, getNewLocalDateFromBack } from 'helper/date.helper';
import { KeyValue } from 'primary/Components/KeyValue/KeyValue';
import {
  getNavigationLinkFromRessourceKey,
  parseRessourceFromNotificaton,
} from 'primary/MessageList/NotificationListItem';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { NotificationResourceTypeEnum } from '../../../domain/notification/NotificationResourceTypeEnum';
import { UnpyNotification } from '../../../domain/notification/UnpyNotification';
import { useContextDependency } from '../../hooks/useContextDependency';
import { useTranslate } from '../../hooks/useTranslate';

interface NotificationInvitationTeamEventContentProps {
  notification: UnpyNotification;
  reFetchNotification: () => void;
  closePreview?: () => void;
}

export const NotificationDateMatchUpdatedContent = ({
  notification,
  reFetchNotification,
  closePreview,
}: NotificationInvitationTeamEventContentProps) => {
  const t = useTranslate();
  const { eventParticipantRepository, teamRepository, eventRepository, authRepository } =
    useContextDependency();
  const ressourcesParsed = parseRessourceFromNotificaton(notification);
  const navigate = useNavigate();

  return (
    <div>
      <div className={'-keyValueContainerNotification'}>
        <div className={'-scoreUpdated'}>
          <KeyValue
            accent
            keyValue={t(
              `notificationList.item.ressourceLabelByKey.${NotificationResourceTypeEnum.EVENT_NAME}`,
            )}
            value={notification.resources[NotificationResourceTypeEnum.EVENT_NAME]}
          />
          <div className={'-content'}>
            <KeyValue
              accent
              keyValue={t(
                `notificationList.item.ressourceLabelByKey.${NotificationResourceTypeEnum.DATE_MATCH}`,
              )}
              value={formatDate(
                getNewLocalDateFromBack(
                  notification.resources[NotificationResourceTypeEnum.DATE_MATCH],
                ),
                'readable(with hour)',
              )}
            />
          </div>
        </div>
      </div>
      <div className={'-linkContainerNotification'}>
        {ressourcesParsed
          .filter((r) => r.isLink)
          .map((res) => (
            <Button
              key={res.keyValue}
              variant={'outlined'}
              className={'-linkNotification'}
              onClick={() => {
                const link = getNavigationLinkFromRessourceKey(
                  res.keyValue as NotificationResourceTypeEnum,
                  res.value,
                  notification.resources,
                  notification.type,
                );
                navigate(link);
                closePreview?.();
              }}
            >
              {t(
                `notificationList.item.ressourceLabelByKey.${
                  res.keyValue as NotificationResourceTypeEnum
                }`,
              )}
            </Button>
          ))}
      </div>
    </div>
  );
};
